import { Component, OnInit } from '@angular/core';
import { BreadcrumbService, Breadcrumb } from './breadcrumb.service';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs$!: Observable<Breadcrumb[]>;

 constructor(private breadcrumbService: BreadcrumbService, private location: Location) {}


  ngOnInit(): void {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
  }
  goBack(): void {
  this.location.back();
}

}
